import { apiService } from '../../shared/services/apiService';
import { SelfSetupCustomer } from '../interfaces/Customer';

export const customerSelfSetupService = {
  async createCustomer(customerInfo: SelfSetupCustomer) {
    const response = await apiService.post<SelfSetupCustomer>(
      '/api/sign-up/customer',
      customerInfo,
    );

    return response.data;
  },

  async updateCustomer(customerId: number, customerInfo: SelfSetupCustomer) {
    const response = await apiService.put<SelfSetupCustomer>(
      `/api/sign-up/customer/${customerId}`,
      customerInfo,
    );

    return response.data;
  },
};
